module.exports = __webpack_public_path__ + "static/media/6635.22dfdbc4.jpg";